import { Guide } from '../../types/guide';
import gettingStarted from './gettingStarted';
import converterTips from './converterTips';
import pdfToMarkdown from './pdfToMarkdown';
import extractTextFromScannedPdf from './extractTextFromScannedPdf';
import mergePdfFiles from './mergePdfFiles';
import pdfPageTools from './pdfPageTools';
import textEditorTips from './textEditorTips';
import cleanUpPdfText from './cleanUpPdfText';
import convertTextFormats from './convertTextFormats';
import regexFindReplace from './regexFindReplace';
import exportToPdf from './exportToPdf';
import typingSpeed from './typingSpeed';
import choosingFileFormat from './choosingFileFormat';

/** All guides, in reading order within each category. */
export const GUIDES: Guide[] = [
  gettingStarted,
  converterTips,
  pdfToMarkdown,
  extractTextFromScannedPdf,
  mergePdfFiles,
  pdfPageTools,
  textEditorTips,
  cleanUpPdfText,
  convertTextFormats,
  regexFindReplace,
  exportToPdf,
  typingSpeed,
  choosingFileFormat,
];

export const getGuideBySlug = (slug: string): Guide | undefined =>
  GUIDES.find((g) => g.slug === slug);

/** Other guides in the same category, then a getting-started fallback. */
export const relatedGuides = (guide: Guide, limit = 3): Guide[] => {
  const sameCategory = GUIDES.filter((g) => g.category === guide.category && g.slug !== guide.slug);
  const others = GUIDES.filter((g) => g.category !== guide.category && g.slug !== guide.slug);
  return [...sameCategory, ...others].slice(0, limit);
};
